import { render, staticRenderFns } from "./PrintKardexDetails.vue?vue&type=template&id=1897c158&scoped=true"
import script from "./PrintKardexDetails.vue?vue&type=script&lang=js"
export * from "./PrintKardexDetails.vue?vue&type=script&lang=js"
import style0 from "./PrintKardexDetails.vue?vue&type=style&index=0&id=1897c158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1897c158",
  null
  
)

export default component.exports